import React, { useEffect, useState } from 'react';
import '.././App.css';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { setDoc, doc } from 'firebase/firestore';
import Swal from 'sweetalert2';


const Register = () => {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const [name, setName] = useState("")
    const [mobile, setMobile] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    const signup = async (e) => {
        e.preventDefault();
        try {
            await createUserWithEmailAndPassword(auth, username, password);
            const user = auth.currentUser;
            if (user) {
                await setDoc(doc(db, "users", user.uid), {
                    email: user.email,
                    mobile: mobile,
                    username: name,
                    password: password,
                    uid: user.uid,
                    role: "General Man"
                });
            }
            Toast.fire({
                icon: "success",
                title: 'User Registered Successfully!!'
            })
            window.location.href = "/home"
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Please Enter Username Or Password'
            })
        }
    }

    return (
        <div style={{ padding: 20 }}>
            <h2>Create User</h2>

            <form onSubmit={signup}>
                <div className="input-group mb-3">
                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" required />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <span className="fas fa-user" />
                        </div>
                    </div>
                </div>
                <div className="input-group mb-3">
                    <input type="text" className="form-control" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Mobile No" required />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <span className="fas fa-phone" />
                        </div>
                    </div>
                </div>
                <div className="input-group mb-3">
                    <input type="email" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required placeholder="Email / Username " />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <span className="fas fa-envelope" />
                        </div>
                    </div>
                </div>
                <div className="input-group mb-3">
                    <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Password" />
                    <div className="input-group-append">
                        <div className="input-group-text">
                            <span className="fas fa-lock" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <button type="submit" className="btn btn-primary btn-block">Register</button>
                    </div>
                </div><br />
            </form>

            <br /><br />
        </div>
    );
};

export default Register;
